<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="12" >
        <label class="text-capitalize">{{
          $t("ai_analytics_servers.servers")
        }}</label>
        <v-select
          label="name"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="serverFilter"
          :options="servers"
          :filterable="false"
          :loading="isLoadingServers"
          class="w-100"
          multiple
          :reduce="(val) => val.id"
          @search="searchServers"
          @input="updateServerFilter"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        >
          <template #list-footer>
            <li class="pagination justify-content-center py-50 mb-0">
              <b-button
                variant="outline-primary"
                size="sm"
                :disabled="isLoadingServers || !hasPreviousServerPage"
                @mousedown.prevent
                @click="previousServerPage"
              >
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </b-button>
              <b-button
                variant="outline-primary"
                size="sm"
                class="ml-50"
                :disabled="isLoadingServers || !hasNextServerPage"
                @mousedown.prevent
                @click="nextServerPage"
              >
                <feather-icon icon="ChevronRightIcon" size="18" />
              </b-button>
            </li>
          </template>
        </v-select>
      </b-col>
      <b-col cols="6" class="mt-1">
        <cameras-proxy-select
          :value="cameraProxyFilter"
          :label="$t('ai_analytics_servers.device')"
          name="camera"
          rules="nullable"
          multiple
          :reduce="(val) => val.value"
          class="mb-1"
          @input="(val) => $emit('update:cameraProxyFilter', val)"
        />
      </b-col>
      <b-col cols="6">
        <label class="text-capitalize">{{
          $t("ai_analytics_servers.status_active")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="statusActiveFilter"
          :options="statusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:statusActiveFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <b-col cols="6">
        <label class="text-capitalize">{{
          $t("ai_analytics_servers.cameras_online")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="camerasOnlineFilter"
          :options="statusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:camerasOnlineFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <b-col cols="6">
        <label class="text-capitalize">Tipo</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="camerasTypesFilter"
          :options="camerasTypesOptions"
          multiple
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:camerasTypesFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <!--<b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("ai_analytics_servers.start_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="startDateFilter"
            @on-change="(selectedDates, val) => $emit('update:startDateFilter', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("ai_analytics_servers.end_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="endDateFilter"
            @on-change="(selectedDates, val) => $emit('update:endDateFilter', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" class="mb-2">
        <CamerasProxySelect
          :value="cameraFilter"
          @input="(val) => $emit('update:cameraFilter', val)"
          :label="$tc('ai_analytics_servers.device', 2)"
          :multiple="true"
          :reduce="(val) => val.value"
        />
      </b-col>-->
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BButton } from "bootstrap-vue";
import { computed, ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import CamerasProxySelect from "@/components/CamerasProxySelect.vue";
import flatPickr from "vue-flatpickr-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";
import { debounce } from "lodash";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BButton,
    vSelect,
    CamerasProxySelect,
    flatPickr,
  },
  props: {
    cameraFilter: {
      type: Array,
      default: () => [],
    },
    cameraOptions: {
      type: Array,
      default: () => [],
    },
    statusActiveFilter: {
      type: Boolean,
      default: null,
    },
    camerasOnlineFilter: {
      type: Boolean,
      default: null,
    },
    startDateFilter: {
      type: String,
      default: null,
    },
    endDateFilter: {
      type: String,
      default: null,
    },
    serverFilter: {
      type: Array,
      default: () => [],
    },
    cameraProxyFilter: {
      type: Array,
      default: () => [],
    },
    camerasTypesOptions: {
      type: Array,
      default: () => [],
    },
    camerasTypesFilter: {
      type: Array,
      default: () => [],
    }
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const serverOptions = ref([]);
    const selectedServers = ref([]);
    const serverPage = ref(1);
    const serverLastPage = ref(1);
    const serverSearch = ref('');
    const isLoadingServers = ref(false);
    let serverRequestId = 0;
    let selectedServersRequestId = 0;

    const statusOptions = [
      { label: t("ai_analytics_servers.online"), value: true },
      { label: t("ai_analytics_servers.offline"), value: false },
    ];

    const servers = computed(() => {
      const selectedIds = new Set(serverOptions.value.map(server => server.id));
      const missingSelectedServers = selectedServers.value.filter(
        server => !selectedIds.has(server.id)
      );

      return [...missingSelectedServers, ...serverOptions.value];
    });

    const loadServers = async (page = 1, search = serverSearch.value) => {
      const requestId = ++serverRequestId;
      isLoadingServers.value = true;

      try {
        const response = await store.dispatch('ai_analytics_servers/servers/getPage', {
          q: search || undefined,
          max: 25,
          'page[n]': page,
          sortBy: 'name',
        });

        if (requestId !== serverRequestId) {
          return;
        }

        serverOptions.value = response.data || [];
        serverPage.value = response.meta?.current_page || page;
        serverLastPage.value = response.meta?.last_page || 1;
      } catch (error) {
        if (requestId === serverRequestId) {
          serverOptions.value = [];
          serverLastPage.value = 1;
        }
      } finally {
        if (requestId === serverRequestId) {
          isLoadingServers.value = false;
        }
      }
    };

    const loadSelectedServers = async (ids) => {
      const requestId = ++selectedServersRequestId;
      const selectedIds = ids || [];
      const cachedServers = [
        ...selectedServers.value,
        ...serverOptions.value,
      ];
      const cachedServersById = new Map(cachedServers.map(server => [server.id, server]));
      const missingIds = selectedIds.filter(id => !cachedServersById.has(id));

      if (missingIds.length) {
        const responses = await Promise.allSettled(
          missingIds.map(id => store.dispatch('ai_analytics_servers/servers/getById', id))
        );
        responses.forEach(response => {
          if (response.status === 'fulfilled' && response.value.data) {
            cachedServersById.set(response.value.data.id, response.value.data);
          }
        });
      }

      if (requestId !== selectedServersRequestId) {
        return;
      }

      selectedServers.value = selectedIds
        .map(id => cachedServersById.get(id))
        .filter(Boolean);
    };

    const updateServerFilter = (ids) => {
      const selectedIds = ids || [];
      selectedServers.value = servers.value.filter(server => selectedIds.includes(server.id));
      emit('update:serverFilter', selectedIds);
    };

    const searchServers = debounce((search) => {
      serverSearch.value = search;
      loadServers(1, search);
    }, 300);

    const hasPreviousServerPage = computed(() => serverPage.value > 1);
    const hasNextServerPage = computed(() => serverPage.value < serverLastPage.value);
    const nextServerPage = () => loadServers(serverPage.value + 1);
    const previousServerPage = () => loadServers(serverPage.value - 1);

    watch(
      () => props.serverFilter,
      (ids) => {
        loadSelectedServers(ids);
      },
      { immediate: true, deep: true }
    );

    loadServers();

    return {
      withPopper: popperHelper.withPopper,
      statusOptions,
      servers,
      isLoadingServers,
      hasPreviousServerPage,
      hasNextServerPage,
      searchServers,
      nextServerPage,
      previousServerPage,
      updateServerFilter,
    };
  },
};
</script>
